import React, { useContext } from 'react';
import { lazyMerge } from '@formily/shared';
import { SchemaExpressionScopeContext } from '../shared';
export var ExpressionScope = function (props) {
    var scope = useContext(SchemaExpressionScopeContext);
    return (React.createElement(SchemaExpressionScopeContext.Provider, { value: lazyMerge(scope, props.value) }, props.children));
};
//# sourceMappingURL=ExpressionScope.js.map